import _Promise from 'babel-runtime/core-js/promise';
/**
 * Created by yxk at 2020/6/1
 * 单个自定义字段生成校验规则
 */
import { regexIsCRMNumber, regexIsCRMMoneyNumber, regexIsCRMMobile, regexIsCRMEmail } from '@/utils';
import { isEmpty, isObject, isArray } from '@/utils/types';

export default {
  methods: {
    /**
     * 唯一性校验
     * @param data
     * @returns {Promise<unknown>}
     * @constructor
     */
    UniquePromise: function UniquePromise(data) {
      return new _Promise(function (resolve) {
        console.log(data);
        resolve();
      });
    },


    /**
     * 生成单个字段的验证规则
     * @param item 字段信息
     * @returns {[]}
     */
    getRules: function getRules(item) {
      var _this = this;

      var tempList = [];

      // 验证必填
      if (item.is_null == 1) {
        tempList.push({
          required: true,
          message: item.name + '不能为空',
          trigger: ['blur', 'change']
        });
        if (item.form_type == 'detail_table') {
          tempList.push({
            validator: function validator(_ref, value, callback) {
              var item = _ref.item;

              if (_this.getDetailTableIsEmpty(item.fieldExtendList, value)) {
                callback(new Error(item.name + '不能为空'));
              } else {
                callback();
              }
            },
            item: item,
            trigger: ['blur', 'change']
          });
        } else if (item.form_type == 'checkbox') {
          tempList.push({
            validator: function validator(_ref2, value, callback) {
              var item = _ref2.item;

              if (!isArray(value) || value.length === 0) {
                callback(new Error(item.name + '不能为空'));
              } else {
                var emptyObj = value.find(function (valueItem) {
                  return isEmpty(valueItem);
                });
                emptyObj === '' ? callback(new Error(item.name + '不能为空')) : callback();
              }
            },
            item: item,
            trigger: ['blur', 'change']
          });
        }
      }

      // 验证唯一
      if (item.is_unique == 1 && this.UniquePromise) {
        var validateUnique = function validateUnique(rule, value, callback) {
          if (isEmpty(value)) {
            callback();
          } else {
            // 验证唯一
            _this.UniquePromise({
              field: item,
              rule: rule,
              value: value
            }).then(function () {
              callback();
            }).catch(function (msg) {
              callback(new Error(msg || '验证出错'));
            });
          }
        };
        tempList.push({
          validator: validateUnique,
          item: item,
          trigger: item.form_type == 'checkbox' || item.form_type == 'select' ? ['change'] : ['blur']
        });
      }
      // 特殊类型
      if (item.form_type === 'number' || item.form_type === 'percent') {
        var validateCRMNumber = function validateCRMNumber(rule, value, callback) {
          if (item.hasOwnProperty('precisions')) {
            _this._getNumberRule(rule, value, callback);
          } else {
            if (isEmpty(value) || regexIsCRMNumber(value)) {
              callback();
            } else {
              callback(new Error('数字的整数部分须少于15位，小数部分须少于4位'));
            }
          }
        };
        tempList.push({
          validator: validateCRMNumber,
          item: item,
          trigger: ['blur']
        });
      } else if (item.form_type === 'floatnumber') {
        var validateCRMMoneyNumber = function validateCRMMoneyNumber(rule, value, callback) {
          if (item.hasOwnProperty('precisions')) {
            _this._getNumberRule(rule, value, callback);
          } else {
            if (isEmpty(value) || regexIsCRMMoneyNumber(value)) {
              callback();
            } else {
              callback(new Error('货币的整数部分须少于15位，小数部分须少于2位'));
            }
          }
        };
        tempList.push({
          validator: validateCRMMoneyNumber,
          item: item,
          trigger: ['blur']
        });
      } else if (item.form_type === 'mobile') {
        var validateCRMMobile = function validateCRMMobile(rule, value, callback) {
          if (isEmpty(value) || regexIsCRMMobile(value)) {
            callback();
          } else {
            callback(new Error('手机格式有误'));
          }
        };
        tempList.push({
          validator: validateCRMMobile,
          item: item,
          trigger: ['blur']
        });
      } else if (item.form_type === 'email') {
        var validateCRMEmail = function validateCRMEmail(rule, value, callback) {
          if (isEmpty(value) || regexIsCRMEmail(value)) {
            callback();
          } else {
            callback(new Error('邮箱格式有误'));
          }
        };
        tempList.push({
          validator: validateCRMEmail,
          item: item,
          trigger: ['blur']
        });
      } else if (item.form_type === 'location' && item.is_null == 1) {
        var validateLocation = function validateLocation(rule, value, callback) {
          if (!isObject(value) || isObject(value) && isEmpty(value.lat) && isEmpty(value.lng) && isEmpty(value.address)) {
            callback(new Error(item.name + '不能为空'));
          } else {
            callback();
          }
        };
        tempList.push({
          validator: validateLocation,
          item: item,
          trigger: ['change']
        });
      }

      return tempList;
    },


    /**
     * 获取数值规则
     */
    _getNumberRule: function _getNumberRule(rule, value, callback) {
      var field = rule.item;

      var arr = String(value).split('.');

      var len = String(value).replace('.', '').replace('-', '').length;
      var maxlength = field.form_type === 'percent' ? 10 : 15;

      var min = isEmpty(field.minNumRestrict) ? -Infinity : Number(field.minNumRestrict || -Infinity);
      var max = isEmpty(field.maxNumRestrict) ? Infinity : Number(field.maxNumRestrict || Infinity);

      if (len > maxlength) {
        callback(new Error('\u6700\u591A\u652F\u6301' + maxlength + '\u4F4D\u6570\u5B57\uFF08\u5305\u542B\u5C0F\u6570\u4F4D\uFF09'));
      } else if (isEmpty(field.precisions) && String(value).includes('.')) {
        // null 不支持小数  0 不限制小数位
        callback(new Error('\u4E0D\u652F\u6301\u5C0F\u6570'));
      } else if (arr.length > 1 && arr[1].length > Number(field.precisions)) {
        callback(new Error('\u5C0F\u6570\u4F4D\u4E0D\u80FD\u5927\u4E8E' + field.precisions));
      } else if (value < min) {
        callback(new Error('\u4E0D\u80FD\u5C0F\u4E8E' + min));
      } else if (value > max) {
        callback(new Error('\u4E0D\u80FD\u5927\u4E8E' + max));
      } else {
        callback();
      }
    },


    /**
     * 判断明细表格是否是空
     * @param {*} fieldList
     * @param {*} valueObj
     */
    getDetailTableIsEmpty: function getDetailTableIsEmpty(fieldList, valueObjs) {
      for (var index = 0; index < valueObjs.length; index++) {
        var valueObj = valueObjs[index];
        if (this.judgeFormValueIsEmpty(fieldList, valueObj)) {
          return true;
        }
      }
      return false;
    },


    /**
     * 判断对象值是否是空
     */
    judgeFormValueIsEmpty: function judgeFormValueIsEmpty(fieldList, valueObj) {
      for (var index = 0; index < fieldList.length; index++) {
        var field = fieldList[index];
        var value = valueObj[field.field];
        if (field.form_type === 'location') {
          if (isObject(value) && (!isEmpty(value.lat) || !isEmpty(value.lng) || !isEmpty(value.address))) {
            return false;
          }
        } else if (!isEmpty(value)) {
          return false;
        }
      }
      return true;
    }
  }
};